var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("PortfolioNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.tchProjectId },
      }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container-fluid",
              staticStyle: { "margin-top": "80px", "padding-top": "20px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(
                      _vm._s(_vm.rm.PortfolioName) +
                        " / " +
                        _vm._s(_vm.rm.ScenarioName)
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "h1",
                    {
                      staticStyle: {
                        "font-size": "2em",
                        "font-weight": "300",
                        color: "#33475b",
                        margin: "0",
                      },
                    },
                    [_vm._v("Plan: P&L")]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-lg-6 d-flex flex-column justify-content-end",
                  },
                  [
                    _c("PortfolioScenarioNavigation", {
                      attrs: {
                        portfolioId: _vm.rm.PortfolioId,
                        corporateScenarioUrl: _vm.rm.CorporateScenarioUrl,
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "toolbar mt-5" }, [
                _c("div", [
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      class: _vm.rm.ApplyBenefitsConfidenceFactor
                        ? "btn-warning"
                        : "btn-outline-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.toggleBenefitsConfidenceFactor()
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fa-regular",
                        class: _vm.rm.ApplyBenefitsConfidenceFactor
                          ? "fa-square-check"
                          : "fa-square",
                      }),
                      _vm._v(
                        "\n                    Risk adjusted benefits\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      class: _vm.rm.CagrVisible
                        ? "btn-info"
                        : "btn-outline-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.toggleCagrVisible()
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fa-regular",
                        class: _vm.rm.CagrVisible
                          ? "fa-square-check"
                          : "fa-square",
                      }),
                      _vm._v("\n                    CAGR\n                "),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "btn-group" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-outline-secondary dropdown-toggle",
                        attrs: { type: "button", "data-toggle": "dropdown" },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.rm.Denomination) +
                            "s\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown-menu" }, [
                      _c(
                        "a",
                        {
                          staticClass: "dropdown-item",
                          on: {
                            click: function ($event) {
                              return _vm.setDenomination("Million")
                            },
                          },
                        },
                        [_vm._v("Millions")]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "dropdown-item",
                          on: {
                            click: function ($event) {
                              return _vm.setDenomination("Thousand")
                            },
                          },
                        },
                        [_vm._v("Thousands")]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "dropdown-item",
                          on: {
                            click: function ($event) {
                              return _vm.setDenomination("Unit")
                            },
                          },
                        },
                        [_vm._v("Units")]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "btn-group" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-outline-secondary dropdown-toggle",
                        attrs: { type: "button", "data-toggle": "dropdown" },
                      },
                      [_vm._v("P&L: " + _vm._s(_vm.selectedPnl.Name))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "dropdown-menu dropdown-menu-right" },
                      _vm._l(_vm.rm.PnlTemplates, function (t) {
                        return _c(
                          "a",
                          {
                            key: t.Id,
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                return _vm.switchPnlTemplate(t.Id)
                              },
                            },
                          },
                          [_vm._v(_vm._s(t.Name))]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm.rm.Report
                ? _c(
                    "div",
                    [
                      _c("PnlViewer", {
                        staticClass: "mt-3",
                        attrs: {
                          readModel: _vm.rm.Report.Report,
                          cagrVisible: _vm.rm.CagrVisible,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }